export default "/dist/files/icon-megaphone-blanc.7a7eb1ffb1c3d7ed6ce38b34601d933f.svg";